import { render, staticRenderFns } from "./FlowVoucherList.vue?vue&type=template&id=52c6dace&scoped=true&"
import script from "./FlowVoucherList.vue?vue&type=script&lang=js&"
export * from "./FlowVoucherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6dace",
  null
  
)

export default component.exports